/** Fired after checkout or Stripe webhooks update subscription billing state. */
export const STRIPE_SUBSCRIPTION_UPDATED_EVENT =
  "vertex360:stripe-subscription-updated";

export function notifyStripeSubscriptionUpdated() {
  if (typeof window !== "undefined") {
    window.dispatchEvent(new CustomEvent(STRIPE_SUBSCRIPTION_UPDATED_EVENT));
  }
}

/**
 * Merge payment_setting from an API response into persisted auth user + Redux.
 * @param {object|null|undefined} paymentSettingPatch
 * @param {Function} dispatch
 * @param {Function} authenticatedUserAction
 */
export function syncAuthUserPaymentSetting(
  paymentSettingPatch,
  dispatch,
  authenticatedUserAction
) {
  if (!paymentSettingPatch || typeof paymentSettingPatch !== "object") {
    return;
  }

  try {
    const raw = localStorage.getItem("user");
    if (!raw) {
      return;
    }
    const user = JSON.parse(raw);
    user.payment_setting = {
      ...(user.payment_setting || {}),
      ...paymentSettingPatch,
    };
    localStorage.setItem("user", JSON.stringify(user));
    dispatch(authenticatedUserAction(user));
  } catch (_) {
    // ignore localStorage parse errors
  }
}
